import { Loading } from "@/layouts/loading";
import Component from "@/routes/(pharma)/_layout/stock-taking/-components/component";
import { createFileRoute } from "@tanstack/react-router";
import { SearchParams } from "./-data/model";

export const Route = createFileRoute("/(pharma)/_layout/stock-taking/" as any)({
    component: Component,
    validateSearch: SearchParams,
    pendingComponent: () => <Loading />,
    pendingMinMs: 1000,
    pendingMs: 1
});
